"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utilities_1 = require("../helpers/utilities");
var addToBag_1 = __importDefault(require("../modules/addToBag"));
var ProductOptions = /** @class */ (function () {
    function ProductOptions() {
        this.config = {
            options: null,
            variants: window.theme.variants,
            selectors: {
                productOption: '[data-product-option]',
                productOptions: '[data-product-options]'
            },
            className: {
                selected: 'product-options__value--selected'
            }
        };
    }
    ProductOptions.prototype.init = function () {
        var _this = this;
        var productOptions = document.querySelectorAll(this.config.selectors.productOptions);
        if (!this.config.variants)
            return;
        if (window.theme.productOptions.firstAvailableVariant)
            this.config.options = window.theme.productOptions.firstAvailableVariant.options;
        if (this.config.options && this.config.variants.length > 1 && productOptions) {
            this.selectOptions(this.config.options);
            productOptions.forEach(function (productOption) { return productOption.addEventListener('change', _this.handleClick.bind(_this, productOption.dataset.productOptions)); });
        }
    };
    ProductOptions.prototype.selectOptions = function (options) {
        var _this = this;
        options.forEach(function (option) {
            document.querySelector("[data-product-option-value=\"".concat(option, "\"]")).classList.add(_this.config.className.selected);
        });
    };
    ProductOptions.prototype.handleClick = function (productOptionsType, event) {
        var target;
        var eventTarget = event.target;
        if (productOptionsType === 'select') {
            target = eventTarget.options[eventTarget.selectedIndex];
        }
        else {
            target = eventTarget;
        }
        var position = parseInt(target.dataset.productOptionPosition);
        var options = document.querySelectorAll(this.config.selectors.productOption);
        var selectedOptions = this.getSelectedOptions(options, position, target);
        var variant = this.getCurrentVariant(selectedOptions);
        var enabled = (variant !== undefined && variant.available);
        var form = document.querySelector('.btn-add-to-bag__form');
        this.clearOptions();
        this.selectOptions(selectedOptions);
        addToBag_1.default.enabled(enabled, form, variant);
        addToBag_1.default.updateVariant(form, variant);
    };
    ProductOptions.prototype.getCurrentVariant = function (selectedOptions) {
        return this.config.variants.find(function (variant) {
            return (0, utilities_1.arrayEquals)(variant.options, selectedOptions);
        });
    };
    ProductOptions.prototype.clearOptions = function () {
        var _this = this;
        var options = document.querySelectorAll(this.config.selectors.productOption);
        options.forEach(function (option) { return option.classList.remove(_this.config.className.selected); });
    };
    ProductOptions.prototype.getSelectedOptions = function (options, position, target) {
        var _this = this;
        return Array.from(options).filter(function (option) {
            return option.classList.contains(_this.config.className.selected);
        }).reduce(function (acc, option, index) {
            var value = option.dataset.productOptionValue;
            if (index === position)
                value = target.dataset.productOptionValue;
            acc.push(value);
            return acc;
        }, []);
    };
    return ProductOptions;
}());
exports.default = new ProductOptions();
